import { experimentStatusColorMap } from "../utils/experimentStatusColorMap";
import styles from "./ExperimentIcon.module.css";
import { experimentIconName } from "@app/config/constants";
import type { ExperimentStatus } from "@globals";
import Icon from "@lib/common/components/Icon/Icon";
import type { ThemeIconProps } from "@mantine/core";
import { Loader, ThemeIcon } from "@mantine/core";

export default function ExperimentIcon({
  status,
  size = "sm",
  ...props
}: { status?: ExperimentStatus | "draft" } & Partial<ThemeIconProps>) {
  const color = experimentStatusColorMap.get(status ?? "waiting");

  if (status === "recommending") {
    return <Loader size={size} />;
  }

  return (
    <ThemeIcon size={size} radius="sm" variant="filled" color={color} {...props} classNames={{ root: styles.root }}>
      <Icon name={experimentIconName} variant="regular" size={size} className={styles.icon} />
    </ThemeIcon>
  );
}
